// extracted by mini-css-extract-plugin
export default {"label":"VacationDaysInfo_label__15L8w","days":"VacationDaysInfo_days__18okg","info":"VacationDaysInfo_info__fOSSv"};